import React from 'react';

import { isMobile } from 'react-device-detect';
import InputLabel from 'components/InputLabel/InputLabel';


export const BeneficiaryOther = ({ otherBeneficiary, setOtherBeneficiary }) => {
	return (
		<InputLabel
			label={'Indica el beneficiario'}
			showLabel={false}
			style={{
				marginTop: 20,
				input: {
					minHeight: 125,
					minWidth: isMobile ? 0 : 600,
				},
			}}
			value={otherBeneficiary}
			onChange={(e) => {
				setOtherBeneficiary(e.target.value);
			}}
		/>
	);
};
